import { useEffect, useState } from "react";

export default function InstagramFeed() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch("https://rsn-gloves.onrender.com/api/instagram/featured")
      .then((res) => res.json())
      .then((data) => setPosts(Array.isArray(data) ? data : []))
      .catch(console.error);
  }, []);

  if (!posts.length) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12 lg:py-16">
      <div className="text-center mb-8">
        <div className="section-kicker">Follow Our Journey</div>
        <h2 className="font-display text-3xl sm:text-4xl font-black text-[#0F172A] mt-2">Latest from RSN Gloves</h2>
        <p className="text-[#66736C] mt-2">Real products. Real workers. Real India.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {posts.map((post) => (
          <a
            key={post.id || post.post_id}
            href={post.permalink || "https://www.instagram.com/rsngloves/"}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white border border-[#DFE7E2] rounded-lg overflow-hidden hover:shadow-lg transition-shadow"
          >
            {post.media_url && (
              <img
                src={post.media_url}
                alt={post.caption || "RSN Gloves Instagram post"}
                loading="lazy"
                className="w-full aspect-square object-cover"
              />
            )}
            {post.caption && (
              <div className="p-4">
                <p className="text-sm text-[#5F6B66] line-clamp-3">{post.caption}</p>
              </div>
            )}
          </a>
        ))}
      </div>
    </section>
  );
}
